import React, { ReactNode } from 'react';
import css from './action-button.module.css';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';

export default function ActionButton({
  name,
  route,
  icon,
  text,
}: {
  name: string;
  route: string;
  icon: ReactNode;
  text: ReactNode;
}) {
  return (
    <div className={css['action-button-box']}>
      <Link data-tip data-for={name} className={css['btn']} to={route}>
        <span className={css['icon']}>{icon}</span>
        <ReactTooltip
          id={name}
          backgroundColor="#002A58"
          place="top"
          effect="solid"
        >
          {text}
        </ReactTooltip>
      </Link>
    </div>
  );
}
